import type { ConfidenceLevel } from '../../types/api';

interface ConfidenceBadgeProps {
  confidence: ConfidenceLevel;
  size?: 'sm' | 'md';
}

const confidenceConfig = {
  high: {
    label: 'High confidence',
    shortLabel: 'High',
    bg: 'bg-success/10',
    text: 'text-success',
    description: 'Very confident match',
  },
  medium: {
    label: 'Medium confidence',
    shortLabel: 'Medium',
    bg: 'bg-warning/10',
    text: 'text-warning',
    description: 'Likely match, but similar species exist',
  },
  low: {
    label: 'Low confidence',
    shortLabel: 'Low',
    bg: 'bg-danger/10',
    text: 'text-danger',
    description: 'Uncertain match, see alternatives below',
  },
};

export function ConfidenceBadge({ confidence, size = 'md' }: ConfidenceBadgeProps) {
  const config = confidenceConfig[confidence];

  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${config.bg} ${config.text} ${sizeClasses}`}
      title={config.description}
    >
      {size === 'sm' ? config.shortLabel : config.label}
    </span>
  );
}
